import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import store from "../store/mainStore";
import useEffectDebugger from "../components/useEffectDebugger";
import { useWhatChanged } from "@simbathesailor/use-what-changed";

const consoleThis = false;

const useDisableBackground = ({ env }) => {
  const parrentComponentMountedRef = useRef(false);

  const loginState = useSelector((state) => state.loginState);
  const loadingState = useSelector((state) => state.loadingState);

  const isLoadingStatic =
    loadingState.loadingBucket.length > 0 ||
    loginState.login.isLoggingInBucket.length > 0 ||
    loginState.register.isRegistring ||
    loginState.login.isReloggingInBucket.length > 0;

  const successState = useSelector((state) => state.successState);
  const isSuccessStatic = successState.showSuccessBucket.length > 0;

  useEffect(() => {
    parrentComponentMountedRef.current = true;

    return () => {
      parrentComponentMountedRef.current = false;
    };
  }, []);

  const isMounted = parrentComponentMountedRef?.current ?? false;

  useEffect(() => {
   
    if (consoleThis) {
      console.log(
        `disabling from ${env}`,
        {
          loading: isLoadingStatic,
          success: isSuccessStatic,
          mounted: parrentComponentMountedRef.current,
        },
        loadingState.loadingBucket
      );
    }
    const activeElement = document.activeElement;
    activeElement.blur();
    document.onkeydown = () => false;
    document.onclick = () => false;
    document.onkeyup = () => false;

    return () => {
      
      //ovo dolazi do trenutne situacije u storu, a ne neupdateane koje su bili na zadnjom renderu
      const isSuccess =
        store.getState().successState.showSuccessBucket.length > 0;
      const isLoading = store.getState().loadingState.loadingBucket.length > 0;

      if (
        isLoading === false &&
        isSuccess === false &&
        parrentComponentMountedRef.current === false
      ) {
        if (consoleThis) {
          console.log(`enabling from ${env}`, {
            loading: isLoading,
            success: isSuccess,
            mounted: parrentComponentMountedRef.current,
          });
        }

        document.onkeydown = () => true;
        document.onclick = () => true;
        document.onkeyup = () => true;
      } else {
        if (consoleThis) {
          console.log(`not enabling from ${env} because of conditions`, {
            loading: isLoading,
            success: isSuccess,
            mounted: parrentComponentMountedRef.current,
          });
        }
      }
      activeElement.focus();
    };
  }, [isLoadingStatic, isSuccessStatic, isMounted]);

  // const depts = [
  //   isMounted,
  //   isLoadingStatic,
  //   isSuccessStatic,
  // ];
  // useWhatChanged(
  //   depts,
  //   "isMounted, isLoadingStatic, isSuccessStatic"
  // );

  //useEffectDebugger(() => {}, [isMounted, isLoadingStatic, isSuccessStatic]);
};

export default useDisableBackground;
